import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'requirements-acknowledgement',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './requirements-acknowledgement.component.html',
  styleUrl: './requirements-acknowledgement.component.scss',
})
export class RequirementsAcknowledgementComponent {
  @Input() projectRequirements: string | null | undefined = null;
  @Input() siteRequirements: string | null | undefined = null;
  @Input() showSite: boolean = false;
  /**
   * Optional override for whether the project has site-level requirements
   * anywhere (used in multi-bid/multi-accept dialogs where individual site
   * requirements aren't displayed but still need to be acknowledged).
   * When null (default), derives from `siteRequirements` for the single-site case.
   */
  @Input() hasSiteRequirements: boolean | null = null;
  /**
   * Fires when the user toggles the checkbox. Currently no parent dialog
   * binds this — they read `acknowledged` directly via a template ref. The
   * output exists to support `[(acknowledged)]` two-way binding in the future.
   */
  @Output() acknowledgedChange = new EventEmitter<boolean>();

  acknowledged: boolean = false;

  get showProject(): boolean {
    return !!this.projectRequirements && this.projectRequirements.trim().length > 0;
  }

  get showSiteSection(): boolean {
    return (
      this.showSite &&
      !!this.siteRequirements &&
      this.siteRequirements.trim().length > 0
    );
  }

  get acknowledgesSite(): boolean {
    if (this.hasSiteRequirements !== null) {
      return this.hasSiteRequirements;
    }
    return !!this.siteRequirements && this.siteRequirements.trim().length > 0;
  }

  get requiresAcknowledgement(): boolean {
    return this.showProject || this.acknowledgesSite;
  }

  get labelText(): string {
    const base = 'I acknowledge that I have read and understood the ';
    const tail = ' requirements for this Project.';
    if (this.showProject && this.acknowledgesSite) {
      return `${base}Project and Site level${tail}`;
    }
    if (this.showProject) {
      return `${base}Project level${tail}`;
    }
    // Site only — getter is only consumed when requiresAcknowledgement is true,
    // so reaching here implies acknowledgesSite is true.
    return `${base}Site level${tail}`;
  }

}
